import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import ServiceNotice from "@/components/ServiceNotice";
import NoticeModal from "@/components/NoticeModal";
import Portal from "@/components/Portal";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[var(--brand-offwhite)]">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <ServiceNotice />
        <Portal />
      </main>
      <Footer />
      <NoticeModal />
    </div>
  );
}
